export const environment = {
  production: true,
  buildId: '2065861281111051',
};
